"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20.45 6.55c-.38-.38-1.01-.38-1.39 0L16.89 8.7c-.39.38-.39 1.01 0 1.39l.01.01c.39.39 1.01.39 1.4 0 .62-.63 1.52-1.54 2.15-2.17.38-.38.38-1 0-1.38zM12.02 3h-.03c-.55 0-.99.44-.99.98v3.03c0 .55.44.99.98.99h.03c.55 0 .99-.44.99-.98V3.98c0-.54-.44-.98-.98-.98zM7.1 10.11l.01-.01c.38-.38.38-1.01 0-1.39L4.96 6.54c-.38-.39-1.01-.39-1.39 0l-.02.01c-.39.39-.39 1.01 0 1.39.63.62 1.53 1.54 2.15 2.17.39.38 1.02.38 1.4 0zM12 15c-1.24 0-2.31-.75-2.76-1.83-.32-.74-1.1-1.17-1.9-1.17H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2h-3.34c-.8 0-1.58.43-1.9 1.17C14.31 14.25 13.24 15 12 15"
}), 'UpcomingRounded');
exports.default = _default;